import styles from '@Styles/BrandingHeader.module.css';

import LanguageSwitch from './core/language-switch';

interface BrandingHeaderProps {
  showLanguageSwitch?: boolean;
}

export const BrandingHeader = ({ showLanguageSwitch = false }: BrandingHeaderProps) => (
  <div
    className={'flex flex-row justify-between items-center headerContainer px-4'}
    style={{ backgroundColor: 'white' }}>
    <div className={styles.logo} />
    {showLanguageSwitch && <LanguageSwitch />}
  </div>
);
